import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { AdminService } from "../../../services/api/admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { AccountRequestsState } from "../../models/mp-admin/account-requests-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class AccountRequestsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.accountRequests.get),
			withLatestFrom(this.store.select(MpAdminSelectors.accountRequests)),
			switchMap(([, state]) =>
				this.canUseStoreValue(state)
					? of(MpAdminActions.accountRequests.getSuccess(state))
					: of(MpAdminActions.accountRequests.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(
				MpAdminActions.accountRequests.getApi,
				MpAdminActions.consumerVerification.updateSuccess,
				MpAdminActions.consumer.activateSuccess,
				MpAdminActions.consumer.denySuccess,
				MpAdminActions.vendorVerification.updateSuccess,
				MpAdminActions.vendor.disableSuccess,
				MpAdminActions.consumer.disableSuccess
			),
			switchMap(() =>
				this.mpAdminService.accountRequests().pipe(
					map((requests) =>
						MpAdminActions.accountRequests.getSuccess({ requests, loading: false })
					),
					catchError((error) =>
						of(MpAdminActions.accountRequests.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private mpAdminService: AdminService
	) {}

	private canUseStoreValue(state: AccountRequestsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
